import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';
const state = {
  userData: {},
  connectionStatus: {
    clientConnected: false,
  },
  queue: [],
  load: false,
  tags: [],
  categories: [],
  expressStatuses: [],
  expressRegional: [],
  expressAssociate: [],
  expressBilletSituation: [],
  userMessage: [],
  newConnectionWapi: {},
};
export default {
  state,
  getters,
  actions,
  mutations,
};
